import { FieldSetProvider } from "../contexts/field-set-context";
import { FieldSetApi } from "../shared/types";

export interface FieldSetProps extends React.HTMLAttributes<HTMLDivElement> {
    fieldSet: FieldSetApi
}

export default function FieldSet({
    fieldSet,
    children,
    ...props
}: FieldSetProps) {
    return <FieldSetProvider fieldSet={fieldSet}>
        <div {...props} ref={fieldSet.ref}>
            {children}
        </div>
    </FieldSetProvider>
}